<template>
  <span style="margin-left: 20px">
    <span class="text-left">
      <button class="btn btn-primary btn-xs" @click.prevent="showCreateAnimal">+</button>
    </span>

    <modal v-show="showModal">
      <h3 slot="header">Create Animal</h3>

      <div slot="body">
        <div class="col-md-8 col-md-offset-2">
          <div class="form-group">
            <label> Animal Name </label>

            <input type="text" required class="form-control" v-model="model.name" ref="aname" />
          </div>

          <div class="form-group">
            <label>Species</label>

            <select class="form-control" v-model="model.species" disabled>
              <option v-for="(option, index) in species" :value="option.value" :key="index">
                {{ option.display }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Breed</label>

            <select class="form-control" v-model="model.breed">
              <option v-for="(option, index) in breedOptions" :value="option.value" :key="index">
                {{ option.display }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label> Animal Notes </label>

            <textarea rows="5" cols="50" v-model="model.notes" class="form-control"> </textarea>
          </div>
        </div>
      </div>

      <div slot="footer">
        <button
          class="btn btn-success"
          @click.prevent="canSave ? saveAnimal() : ''"
          v-tooltip="getSaveTooltip"
          :title="getSaveTooltip"
          :class="{ disabled: !canSave }"
        >
          Save
        </button>
        <button class="modal-default-button btn btn-default" @click.prevent="showModal = false">Cancel</button>
      </div>
    </modal>
  </span>
</template>

<script>
import Modal from '@/components/Modal'
import { getCurrentUser } from '@/_helpers'
import { mapMutations } from 'vuex'

export default {
  name: 'CreateAnimalForm',
  components: {
    Modal,
  },
  props: {
    animalType: String,
  },
  data() {
    return {
      showModal: false,
      model: {
        name: '',
        species: null,
        breed: null,
        notes: '',
        is_active: true,
        is_consult_animal: true,
      },
    }
  },
  methods: {
    ...mapMutations('currentConsult', ['createAnimal']),
    speciesIdFromAnimalType: function () {
      return {
        beef: 4,
        sheep: 12,
        deer: 17,
        dairy_support: 4,
      }[this.animalType]
    },
    showCreateAnimal: function () {
      this.showModal = true
    },
    saveAnimal: function () {
      this.createAnimal(this.model)
      this.$emit('animal-created', this.model)
      this.showModal = false
    },
    setSpecies: function () {
      this.model.species = this.speciesIdFromAnimalType()
      this.model.best_calc_type = this.animalType == 'dairy_support' ? 'dairy' : this.animalType
      this.model.is_consult_animal = true
    },
    resetForm: function () {
      this.model = {
        name: '',
        description: '',
        species: null,
        breed: null,
        notes: '',
        is_active: true,
        is_consult_animal: true,
      }
    },
  },
  computed: {
    species: function () {
      return this.$store.state['currentConsult'].models['ClientDetails'].SPECIES
    },
    canSave: function () {
      return Boolean(this.model.name && this.model.species && this.model.breed)
    },
    breedOptions: function () {
      return this.model.species ? this.species.find((s) => s.value == this.model.species).breeds : []
    },
    getSaveTooltip: function () {
      return this.canSave ? 'Create Animal' : 'Please fill the form first'
    },
  },
  watch: {
    'model.species': function (val) {
      this.model.breed = val
        ? this.breedOptions.find((o) => {
            return this.animalType == 'dairy_support'
              ? o.display.startsWith('Unknown') && o.display.includes('Dairy')
              : o.display.startsWith('Unknown')
          }).value
        : null
    },
    showModal: function (val) {
      if (val) {
        this.setSpecies()
        this.model.notes = `GF Consult animal created by ${getCurrentUser().full_name}`
        this.$nextTick(() => this.$refs.aname.focus())
      } else {
        this.resetForm()
      }
    },
  },
}
</script>
